<template>
  <div>
    <Modal v-model="visible" :title="formData.id ? '编辑' : '新增'" width="500" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <Form v-if="showPupUp" ref="form" :model="formData" class="full form" :label-width="100">
        <FormItem v-if="formData.id" prop="code" label="基本法code" class="full" :rules="$units.formRule.required('请输入')">
          <span>{{ formData.code }}</span>
        </FormItem>

        <FormItem prop="name" label="基本法名称" :rules="$units.formRule.required('请输入')" class="full">
          <Input :maxlength="30" clearable v-model="formData.name" placeholder="最多输入30个字" />
        </FormItem>

        <FormItem prop="remark" label="备注" class="full">
          <Input :maxlength="60" type="textarea" :rows="4" v-model="formData.remark" placeholder="最多输入60个字" />
        </FormItem>
      </Form>

      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      visible: false,
      showPupUp: false,
      formData: {}
    };
  },
  methods: {
    open(data = {}) {
      this.visible = true;
      this.showPupUp = true;
      this.formData = {};
      if (data.id) {
        this.formData.id = data.id;
        this.getDetail();
      }
      this.$refs.form && this.$refs.form.resetFields();
    },
    getDetail() {
      this.$http({
        url: '/buz/baseMethod/read/detail',
        type: 'GET',
        data: {
          id: this.formData.id
        }
      }).then(res => {
        this.formData = res.data;
      });
    },

    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }

        let data = {
          ...this.formData
        };
        console.log(data);
        this.$http({
          url: this.formData.id ? '/buz/baseMethod/edit' : '/buz/baseMethod/add',
          type: 'POST',
          data
        }).then(res => {
          this.formData = {};
          this.$notice.success('操作成功');
          this.visible = false;
          this.$emit('reload')
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  .form {
    margin-top: 10px;
  }

  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
    }
  }
}
</style>
